import { css, cva } from '@/styled-system/css';
import { shimmerStyles } from '@zg-rentals/loading-components';

export const backgroundImageRecipe = cva({
  base: {
    alignItems: 'flex-end',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    borderRadius: '100',
    display: 'flex',
    height: { base: '90px', lg: '100px' },
    justifyContent: 'flex-end',
    padding: '200',
    position: 'absolute',
    width: '100%',

    _before: {
      // eslint-disable-next-line curly-quotes/no-straight-quotes
      content: '""',
      position: 'absolute',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
    },
  },
  variants: {
    isDisabled: {
      true: {
        cursor: 'not-allowed',
      },
      false: {
        cursor: 'pointer',
      },
    },
    hasError: {
      true: {
        _before: {
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
        },
      },
      false: {
        _before: {
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
        },
      },
    },
  },
});

export const backgroundLoadingImageStyles = css.raw({
  borderRadius: '100',
  height: { base: '90px', lg: '100px' },
  position: 'absolute',
  width: '100%',
  ...shimmerStyles,
});

export const backgroundImageContainerStyles = css.raw({
  height: { base: '90px', lg: '100px' },
  position: 'relative',
  touchAction: 'none',
});
